<template>
  <v-card
    :max-height="this.height"
    :max-width="this.width"
    :min-width="this.width"
    :class="(this.showBoxShadow ? 'box-shadow' : 'no-box-shadow') + (this.showBorder ? ' ' : ' no-border') + (this.showBackground ? ' ' : ' no-background')"
  >
    <slot name="header">
      <v-card-text class="pl-5 pr-5 pt-5 pb-0" style="width: 100%"
                   v-if="headerText || beforeBookmarkText || showBookmark">
        <v-row class="ml-0 mr-0">
          <v-col>
            <span class="header mt-2">{{ headerText }}</span>
            <v-spacer/>
            <v-chip class="mt-1 beforeBookmark fin-color-primary-dark--text "
                    small
                    v-if="beforeBookmarkText">
              {{ beforeBookmarkText }}
            </v-chip>
            <fin-bookmark-btn content-style="margin-top: -2px; height: 16px;" v-if="showBookmark"/>
          </v-col>
        </v-row>
      </v-card-text>
    </slot>

    <slot name="preTitle"/>

    <slot name="title" v-if="titleText">
      <div class="mx-6 mt-7 pa-0 cardTitle">{{titleText}}</div>
    </slot>

    <slot name="content" style="width: 100%"/>

    <template v-if="$slots.actions || fincraftVerified">
      <v-divider class="mt-6"/>
      <v-card-actions class="pr-6">
        <slot name="actions"/>
        <v-spacer/>
        <fin-logo-sign class="mr-n2" dark v-if="fincraftVerified"/>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import finBookmarkBtn from '@/components/common/BookmarkBtn'
import finLogoSign from '@/components/common/logo/LogoSign'

export default {
  name: 'fin-entity-card',
  components: {finBookmarkBtn, finLogoSign},
  props: {
    headerText: {type: String},
    beforeBookmarkText: {type: String},
    showBookmark: {type: Boolean, default: false},
    titleText: {type: String},
    fincraftVerified: {type: Boolean, default: false},
    height: {type: Number},
    width: {type: Number},
    href: {type: String},
    showBoxShadow: {type: Boolean, default: true},
    showBorder: {type: Boolean, default: true},
    showBackground: {type: Boolean, default: true}
  }
}
</script>

<style lang="scss" scoped>
  .header {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #888999;
  }

  .beforeBookmark {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    border-radius: 0;
    height: 22px;
    background-color: #f7f7f7 !important;

    &:hover:before,
    &:focus:before {
      opacity: 0 !important;
    }
  }

  .cardTitle {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    /* additionally needed */
    word-break: normal;
  }

  .box-shadow {
    box-shadow: $fin-color-card-shadow !important;
    border: solid 1px #e0e2e3;
    background-color: white;
  }

  .no-box-shadow {
    box-shadow: none !important;
  }

  .no-border {
    border: 0 !important;
  }

  .no-background {
    background: transparent;
  }
</style>
